import React, { useEffect, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import Logo from "../images/managekaro logo.png";
import counterpart from "counterpart";
import eng from "../lang/eng";
import urdu from "../lang/urdu";
import { useHistory, withRouter } from "react-router";
import axios from "axios";
import notificationsgreen from "../images/bell-green.png";
import notificationBell from "../images/notification-bell.png";
import { useDispatch, useSelector } from "react-redux";
import { getCompany } from "./company profile/companySlice";
import { Stack, Hidden, AppBar, Toolbar } from "@mui/material";
import { Drawer, Divider, List, Typography, Button } from "@mui/material";
import { IconButton, CssBaseline, ListItem, Box, styled } from "@mui/material";
import Close from "@material-ui/icons/Close";
// import BarcodeGreen from "../../images/barcode-green.svg";
// import BarcodeGrey from "../../images/barcode-grey.svg";
// import BillGreen from "../../images/bill-green.png";
// import BillGrey from "../../images/bill-grey.svg";
// import CompanyProfileGreen from "../../images/companyProfile-green.svg";
// import CompanyProfileGrey from "../../images/companyProfile-grey.svg";
// import DailyBookGreen from "../../images/dailyBook-green.svg";
// import DailyBookGrey from "../../images/dailyBook-grey.svg";
// import DashboardGreen from "../../images/dashboard-green.svg";
// import DashboardGrey from "../../images/dashboard-grey.svg";
// import InvoiceGreen from "../../images/invoice-green.svg";
// import InvoiceGrey from "../../images/invoice-grey.svg";
// import ItemGreen from "../../images/item-green.svg";
// import ItemGrey from "../../images/item-grey.svg";
// import LedgerGreen from "../../images/ledger-green.svg";
// import LedgerGrey from "../../images/ledger-grey.svg";
// import LocationGreen from "../../images/location-green.svg";
// import LocationGrey from "../../images/location-grey.svg";
// import PurchaseGreen from "../../images/purchase-green.svg";
// import PurchaseGrey from "../../images/purchase-grey.svg";
// import QuotationGreen from "../../images/quotation-green.svg";
// import QuotationGrey from "../../images/quotation-grey.svg";
// import ReportGreen from "../../images/report-green.svg";
// import ReportGrey from "../../images/report-grey.svg";
// import SalaryGreen from "../../images/salary-green.svg";
// import SalaryGrey from "../../images/salary-grey.svg";
// import SaleReturnGreen from "../../images/saleReturnBill-green.svg";
// import SaleReturnGrey from "../../images/saleReturnBill-grey.svg";
// import SummaryGreen from "../../images/summary-green.svg";
// import SummaryGrey from "../../images/summary-grey.svg";
// import VendorGreen from "../../images/vendor-green.svg";
// import VendorGrey from "../../images/vendor-grey.svg";
// import WareHouseGreen from "../../images/warehouse-green.svg";
// import WareHouseGrey from "../../images/warehouse-grey.svg";
// import WareHouseBillGreen from "../../images/warehouse-green.svg";
// import WareHouseBillGrey from "../../images/warehouseBill-grey.svg";
// import SalesGreen from "../../images/salary-green.svg";
// import SalesGrey from "../../images/sale-grey.svg";

counterpart.registerTranslations("eng", eng);
counterpart.registerTranslations("urdu", urdu);

counterpart.setLocale("eng");

const drawerWidth = 240;

const BtnMenu = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
  zIndex: 1,
  [theme.breakpoints.up("sm")]: {
    display: "none",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  margin: "16px 0",
  fontWeight: "bold",
  [theme.breakpoints.down("md")]: {
    fontSize: "13px",
  },
}));

function ResponsiveDrawer(props) {
  const { container, lang } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { company } = useSelector((state) => state.company);
  console.log("company:", company);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [state, setState] = useState({
    selected: "",
  });

  useEffect(() => {
    if (!company) {
      dispatch(getCompany());
    }
  }, []);

  const toggle = () => {
    setMobileOpen(!mobileOpen);
  };

  counterpart.setLocale(lang);

  const handleClick = (item) => {
    setState((prev) => ({ ...prev, selected: item }));
    toggle();
  };
  const handleLogout = () => {
    localStorage.clear();
    // setTimeout(() => {
    //   history.push("/inventory/login");
    // }, 500);
    history.push("/inventory/login");
    window.location.reload();
  };

  const drawer = (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Stack width="100%" justifyContent="center">
          <Link onClick={toggle} to="/inventory/dashboard">
            <img
              style={{ paddingLeft: "20px", margin: "10px 0" }}
              className="logoicon"
              src={Logo}
              alt="logo"
            />
          </Link>
        </Stack>
        <Divider />
        <List>
          {company?.featuresAccess &&
            company?.featuresAccess?.map((item) => {
              return (
                <Link to={`/inventory/dashboard/${item.url}`}>
                  <div onClick={() => handleClick(item.url)}>
                    <ListItem onClick={toggle} button>
                      <img
                        className="logoiconsm"
                        src={
                          state.selected == `${item.url}`
                            ? item.selectCard
                            : item.card
                        }
                        alt="logo"
                      />

                      <h4>{item.title}</h4>
                    </ListItem>
                  </div>
                </Link>
              );
            })}
        </List>
      </Box>

      <Box sx={{ background: "white" }}>
        <Divider />

        <Stack width="100%" alignItems="center" justifyContent="center">
          <Title
            sx={{
              margin: "0",
              textAlign: "center",
              fontSize: "12px",
              fontWeight: "normal",
            }}
          >
            Logged In as:
          </Title>
          <Title
            sx={{
              margin: "0",
              textAlign: "center",
              fontSize: "12px",
              fontWeight: "normal",
            }}
          >
            {localStorage.getItem("token")}
          </Title>
          <Box sx={{ my: 0.5 }}>
            <Button
              size="small"
              variant="contained"
              sx={{ boxShadow: "none", textTransform: "none" }}
              onClick={handleLogout}
            >
              Logout
            </Button>
          </Box>
        </Stack>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="fixed"
        sx={{
          background: "#FFFFFF",
          boxShadow: "none",
          px: { xs: "1px", md: "60px" },
          display: { xs: "flex", sm: "none", md: "none" },
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            aria-label="menu"
            sx={{ mr: 2, display: { xs: "flex", sm: "flex", md: "none" } }}
            onClick={toggle}
          >
            <MenuIcon />
          </IconButton>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: { xs: "center", sm: "start" },
            }}
          >
            <img src={Logo} alt="logo" />
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { xs: "50%", sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: { xs: "50%", sm: drawerWidth },
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="nav"
        sx={{
          display: { xs: "none", sm: "block" },
          width: drawerWidth,
          flexShrink: { sm: 0 },
        }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="permanent"
          open={mobileOpen}
          onClose={toggle}
          sx={{
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

ResponsiveDrawer = withRouter(ResponsiveDrawer);

export { ResponsiveDrawer };
